import React from 'react';
import Notification from './components/NotificationComponent';
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_NOTIFICATION } from './constants';

export default function NotificationSelector({ children }) {
  const notificationStatus = useSelector((state) => state.notificationState);
  const dispatch = useDispatch();

  return (
    <>
      <Notification
        open={notificationStatus.open}
        type={notificationStatus.type}
        message={notificationStatus.message}
        setOpen={() =>
          dispatch({ type: SHOW_NOTIFICATION, data: { open: false } })
        }
      />
      {children}
    </>
  );
}
